// Верхний уровень сложности бота (зеркало redis_server.MAX_BOT_LEVEL на сервере).
const MAX_BOT_LEVEL = 2

const state = {
  // 🔴 Фракция до ответа сервера — ДОГАДКА (дефолт стора). Обучение ведёт игрока по ЕГО стороне,
  // поэтому ему нужен признак «конфиг реально пришёл»: иначе эльфу подсвечивались зомби-фигуры.
  configLoaded: false,
  fraction: 'Zombie',
  mode: 'KillKingTimer',
  // allowBot: согласие на подсадку бота-оппонента, если за ~15с не нашлось живой пары.
  // Матч с ботом тренировочный — НЕ приносит энергию/рейтинг и из ботов не сыпется лут (гейт на сервере).
  allowBot: false,
  // botSurrender: разрешить боту сдаваться в безнадёжной позиции (соперник ≥3× по силе) — не тянуть время.
  // По умолчанию ВКЛ (экономит время тренировки); кто хочет дожать бота полностью — снимает галочку.
  botSurrender: true,
  // botLevel: УРОВЕНЬ сложности подсадного бота, ползунок в лобби. ТРИ ступени (решение оунера
  // 2026-08-07, до этого было восемь):
  //   0 — лёгкий: без тактической карты силы и без мозга, партия не приносит ничего;
  //   1 — средний: ТОЛЬКО карта силы (ходы выбирает каскад правил), падают амуниция и ресурсы;
  //   2 — сложный: поисковый мозг (прежняя «Легенда» — глубина 10, до 30 с на ход); плюс к добыче
  //   энергия в БАЛАНС за взятые фигуры. Рейтинг не растёт ни на каком уровне.
  // 🔴 Кламп до MAX_BOT_LEVEL: в сохранённых конфигах остались уровни 3-7 — читаем их как «сложный».
  botLevel: 0,
  // powerDeviation: допуск отклонения совокупной силы армии соперника при матчмейкинге (ползунок PvP).
  // 0.05..0.5 (±5%..±50%). Матчимся только с игроком, чья сила в пределах допуска ОБЕИХ сторон.
  // Дефолт ±5% (решение оунера 2026-07-26) — тот же, что подставляет сервер, если поля в конфиге нет.
  powerDeviation: 0.05,
  // hints: 'on',
  status: undefined,
  users: []
};

const getters = {};

const mutations = {
  SET_FRACTION: (state, payload) => {
    state.fraction = payload
  },
  // 🔴 СТОРОНА ПОДТВЕРЖДЕНА СЕРВЕРОМ (ставится ПОСЛЕ успешного `SAVE_CONFIG` на выборе фракции).
  // Раньше `configLoaded` поднимал только ответ входа (`current_config`), а он у новичка приходит
  // ПУСТЫМ — стороны ещё нет. Выбрав фракцию, игрок весь первый сеанс жил с `configLoaded = false`,
  // и обучение считало сторону «догадкой»: гейт первой партии (своя фракция + подсадной бот) не
  // включался, и новичка могло унести в очередь к ЖИВОМУ сопернику. Разбор 2026-08-25.
  CONFIG_SAVED: (state) => {
    if (state.fraction) state.configLoaded = true
  },
  SET_MODE: (state, payload) => {
    state.mode = payload
  },
  SET_ALLOW_BOT: (state, payload) => {
    state.allowBot = payload
  },
  SET_BOT_SURRENDER: (state, payload) => {
    state.botSurrender = payload
  },
  SET_BOT_LEVEL: (state, payload) => {
    state.botLevel = Math.max(0, Math.min(MAX_BOT_LEVEL, parseInt(payload, 10) || 0))
  },
  SET_POWER_DEVIATION: (state, payload) => {
    state.powerDeviation = payload
  },
  // SET_HINTS: (state, payload) => {
  //   state.hints = payload
  // },
  SET_STATUS: (state, payload) => {
    state.status = payload
  },
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_CONFIGS: (state, payload) => {
    if (!payload) return   // новичок ещё не выбрал сторону — конфига нет, догадку не подтверждаем
    // «конфиг пришёл» = сервер прислал сторону; обучение ждёт именно этого признака
    if (payload.fraction) { state.configLoaded = true; state.fraction = payload.fraction }
    state.mode = payload.mode
    // Ползунок допуска силы восстанавливаем из сохранённого конфига: без этого при каждом заходе он
    // молча падал на дефолт, и игрок, выставивший широкий допуск, снова искал соперника в узкой полосе.
    const dev = Number(payload.power_deviation)
    if (dev > 0) state.powerDeviation = dev
    // уровень сложности бота восстанавливаем из конфига — иначе выбор сбрасывался при каждом заходе
    // (фолбэк со старого булева bot_hard: true→1, для конфигов, сохранённых до появления уровней)
    if (payload.bot_level !== undefined && payload.bot_level !== null) {
      state.botLevel = Math.max(0, Math.min(MAX_BOT_LEVEL, parseInt(payload.bot_level, 10) || 0))
    } else if (payload.bot_hard !== undefined) {
      state.botLevel = payload.bot_hard ? 1 : 0
    }
    if (payload.allow_bot !== undefined) state.allowBot = !!payload.allow_bot
    if (payload.bot_surrender !== undefined) state.botSurrender = !!payload.bot_surrender
    // state.hints = payload.hints
  }
};

const actions = {
  SAVE_CONFIG: async (context, app) => {
    await app.$http.post(
      '/users/config',
      {
        "fraction": state.fraction,
        "mode": state.mode,
        "allow_bot": state.allowBot,
        "bot_surrender": state.botSurrender,
        "bot_level": state.botLevel,
        // bot_hard шлём для совместимости (старые гейты/фолбэк сервера): уровень ≥ 1 = «сложный» по-старому
        "bot_hard": state.botLevel >= 1,
        "power_deviation": state.powerDeviation
      }
    )
  },
  SET_STATUS: async (context, status) => {
    context.commit('SET_STATUS', status)
  },
  GET_USERS: async (context, app) => {
    const users = await app.$http.get(
      '/users/',
      state
    )
    context.commit('SET_USERS', users?.data)
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
